import React from 'react';
import Icon from '../../../components/AppIcon';

const ActorPerformanceCard = ({ actor }) => {
  const getQualityColor = (score) => {
    if (score >= 90) return 'text-success';
    if (score >= 75) return 'text-warning';
    return 'text-error';
  };

  const getQualityBadge = (score) => {
    if (score >= 90) return 'bg-success/10 border-success text-success';
    if (score >= 75) return 'bg-warning/10 border-warning text-warning';
    return 'bg-error/10 border-error text-error';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-all duration-200">
      {/* Actor Header */}
      <div className="flex items-start gap-4 mb-4">
        <div className="w-16 h-16 rounded-full bg-gradient-to-br from-primary to-primary/60 flex items-center justify-center flex-shrink-0">
          {actor?.headshotUrl ? (
            <img
              src={actor?.headshotUrl}
              alt={`${actor?.stageName} headshot`}
              className="w-full h-full rounded-full object-cover"
            />
          ) : (
            <Icon name="User" size={32} className="text-white" />
          )}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-bold text-card-foreground truncate">{actor?.stageName}</h3>
          <p className="text-sm text-muted-foreground">{actor?.vocalRange || 'N/A'}</p>
          <div className="flex items-center gap-2 mt-1">
            <span className={`px-2 py-0.5 rounded-full border text-xs font-medium ${getQualityBadge(actor?.avgQualityScore || 0)}`}>
              Quality: {actor?.avgQualityScore || 0}/100
            </span>
          </div>
        </div>
      </div>
      {/* Performance Metrics */}
      <div className="space-y-3">
        {/* Lines Recorded */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Icon name="Mic" size={16} className="text-primary" />
            <span className="text-sm text-muted-foreground">Lines Recorded</span>
          </div>
          <span className="text-sm font-semibold text-card-foreground">
            {actor?.totalLinesRecorded} / {actor?.totalLinesAssigned}
          </span>
        </div>

        {/* Completion Progress */}
        <div>
          <div className="flex items-center justify-between mb-1">
            <span className="text-sm text-muted-foreground">Completion</span>
            <span className="text-sm font-semibold text-card-foreground">{actor?.completionPercentage}%</span>
          </div>
          <div className="w-full bg-muted rounded-full h-2">
            <div
              className={`h-2 rounded-full transition-all ${
                actor?.completionPercentage >= 80
                  ? 'bg-success'
                  : actor?.completionPercentage >= 50
                  ? 'bg-warning' :'bg-error'
              }`}
              style={{ width: `${actor?.completionPercentage}%` }}
            ></div>
          </div>
        </div>

        {/* Audio File Status */}
        <div className="pt-3 border-t border-border">
          <div className="grid grid-cols-3 gap-2 text-center">
            <div>
              <div className="text-xs text-muted-foreground mb-1">Completed</div>
              <div className="text-lg font-bold text-success">{actor?.audioFileStatuses?.completed || 0}</div>
            </div>
            <div>
              <div className="text-xs text-muted-foreground mb-1">Pending</div>
              <div className="text-lg font-bold text-warning">{actor?.audioFileStatuses?.pending || 0}</div>
            </div>
            <div>
              <div className="text-xs text-muted-foreground mb-1">Rejected</div>
              <div className="text-lg font-bold text-error">{actor?.audioFileStatuses?.rejected || 0}</div>
            </div>
          </div>
        </div>

        {/* Additional Stats */}
        <div className="pt-3 border-t border-border space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Recording Sessions</span>
            <span className="font-semibold text-card-foreground">{actor?.recordingSessions || 0}</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Avg Session Duration</span>
            <span className="font-semibold text-card-foreground">{actor?.avgSessionDuration || 0} min</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-1.5">
              <Icon name="Users" size={14} className="text-accent" />
              <span className="text-muted-foreground">Followers</span>
            </div>
            <span className="font-semibold text-card-foreground">{actor?.followerCount || 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActorPerformanceCard;